<template>
  <el-main>
    <component :is="chart"></component>
    <edit-chart :chart-name="chart"/>
  </el-main>
</template>

<script>
  /*
    edit chart children component from audit mixin
    for add new edit chart u need import chart-component here
  */

  // components from Common
  import Views from "../../analytics/components/tabs/components/audit/components/Views";
  import Involvement from "../../analytics/components/tabs/components/audit/components/Involvement";
  import Sex from "../../analytics/components/tabs/components/audit/components/Sex";
  import Age from "../../analytics/components/tabs/components/audit/components/Age";
  import SummaryLikesAndReposts from "../../analytics/components/tabs/components/audit/components/SummaryLikesAndReposts";

  // native components
  import EditChart from "./editChart/EditChart";

  export default {
    name: "PageContent",
    computed: {
      chart() {
        return this.$route.params.chart;
      }
    },
    components: {
      Views,
      Involvement,
      Sex,
      Age,
      SummaryLikesAndReposts,
      EditChart
    },
  };
</script>
